<template>
  <button
    ref="dropdownButton"
    :class='{ "opacity-25": !accepted }'
    aria-label="Menu"
    :disabled="!accepted"
    :aria-disabled="!accepted"
    @click="onDropdownClick()"
  >
    <img
      :src="photoURL"
      class="rounded-circle"
      width="38"
      height="38"
      :alt="buttonAltText"
      loading="lazy"
    />
  </button>
</template>

<script setup lang="ts">
import { Ref, computed, onMounted, ref, watch } from 'vue';
import { UserState } from "../../userState";
import { injectRequired } from '../../utilities/injectRequired';
import { useCookieConsent } from '../../composables/cookieConsent';
import { createPopper, flip, preventOverflow } from '@popperjs/core';

const props = defineProps<{
  dropdownMenu: HTMLElement
}>();

const dropdownButton = ref();

const userState = injectRequired<Ref<UserState>>('userState');

const { accepted } = useCookieConsent();

const settingsIconUrl = new URL("../../assets/settings-icon-64x64.png", import.meta.url).toString();
const defaultAvatarIconUrl = new URL("../../assets/default-avatar-icon-64x64.png", import.meta.url).toString();

const photoURL = computed(() => {
  if (userState.value.loading) return undefined;
  if (userState.value.photoURL) return userState.value.photoURL;
  if (userState.value.isSignedIn && !userState.value.isAnonymous) return defaultAvatarIconUrl;
  return settingsIconUrl;
});

const buttonAltText = computed(() => {
  if (userState.value.loading) return undefined;
  return userState.value.photoURL ? "small profile photo" : "gear icon"
});


let popperInstance: any;
watch(() => props.dropdownMenu, () => {
  if (popperInstance) return;
  if (!props.dropdownMenu) return;
  popperInstance = createPopper(dropdownButton.value, props.dropdownMenu, {
    placement: "bottom-end",
    modifiers: [
      flip, 
      preventOverflow,
    ],
  });
});

onMounted(() => {
});

function onDropdownClick() {
  props.dropdownMenu.setAttribute('data-show', '');
  popperInstance.update();
}
</script>